var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 39,
    viewBox: "0 0 32 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 38,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 38,
    rx: 3.5,
    stroke: "#534E54"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 19.5V8.5C6 8.23478 6.10536 7.98043 6.29289 7.79289C6.48043 7.60536 6.73478 7.5 7 7.5H19L26 14.5V19.5",
    stroke: "#534E54",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 7.5V14.5H26",
    stroke: "#534E54",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 28.5H8C8.53043 28.5 9.03914 28.2893 9.41421 27.9142C9.78929 27.5391 10 27.0304 10 26.5C10 25.9696 9.78929 25.4609 9.41421 25.0858C9.03914 24.7107 8.53043 24.5 8 24.5H6V30.5",
    stroke: "#534E54",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27 24.5H23.5V30.5",
    stroke: "#534E54",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 28H23.5",
    stroke: "#534E54",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 30.5C16.7956 30.5 17.5587 30.1839 18.1213 29.6213C18.6839 29.0587 19 28.2956 19 27.5C19 26.7044 18.6839 25.9413 18.1213 25.3787C17.5587 24.8161 16.7956 24.5 16 24.5H14.25V30.5H16Z",
    stroke: "#534E54",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfFile);
export default __webpack_public_path__ + "static/media/pdf-file.a4adf5420a1c6600a8c31760594e2414.svg";
export { ForwardRef as ReactComponent };